import { Box, Button, Divider, FormLabel, Grid, IconButton, Input, Modal, SelectChangeEvent, Stack, Switch, Typography } from "@mui/material";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import InputCep from "../../../../../components/inputs/cepInput";
import { ServicesCadastrar as useServices } from './service';
import { SelectSedeGrupo } from "../../../../../components/selects/grupoSede";

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 2,
};

export default function AddSede() {

  const { cadastrarCelula, celulaSelecionada, changeCampusCelula } = useServices();

  const router = useNavigate();

  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    router(-1);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography id="modal-modal-title" variant="h5" component="h2">
              Sede
            </Typography>
            <IconButton aria-label="fechar" size="medium" onClick={handleClose}>
              <CloseRoundedIcon fontSize="inherit" />
            </IconButton>
          </div>
          <Divider />
          <Grid display={'grid'} gap={'8px'} mt={1} gridTemplateColumns={{ lg: 'repeat(2, 1fr)' }}>

            <Grid item display={'grid'}>
              <InputCep
                onChange={(value) => changeCampusCelula('cep', value)}
                value={celulaSelecionada?.cep}
              />
            </Grid>

            <Grid item display={'grid'}>
              <SelectSedeGrupo
                action={(value) => changeCampusCelula('cep', value)}
                value={celulaSelecionada?.cep}
              />
            </Grid>

            <Grid item display={'grid'}>
            <FormLabel>Nome</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('nomefantasia', String(value?.target?.value)?.trim())}
                defaultValue={celulaSelecionada?.nomefantasia || ''}
              />
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>CNPJ</FormLabel>
              <Input
               inputProps={{
                "maxLength": 14
              }}
                onChange={(value) => changeCampusCelula('cnpj', String(value?.target?.value)?.trim())}
                defaultValue={celulaSelecionada?.cnpj || ''}
              />
            </Grid>



            <Grid item display={'grid'}>
              <FormLabel>Telefone</FormLabel>
              <Input
                inputProps={{
                  "maxLength": 12
                }}
                onChange={(value) => changeCampusCelula('telefone', String(value?.target?.value)?.trim())}
                defaultValue={celulaSelecionada?.telefone || ''}
              />
            </Grid>


            <Grid item display={'grid'}>
              <FormLabel>Bairro</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('bairro', String(value?.target?.value)?.trim())}
                defaultValue={celulaSelecionada?.bairro || ''}
              />
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>Rua</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('rua', String(value?.target?.value)?.trim())}
                defaultValue={celulaSelecionada?.rua || ''}
              />
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>Numero</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('numero', String(value?.target?.value)?.trim())}
                defaultValue={celulaSelecionada?.numero || ''}
              />
            </Grid>


          </Grid>
          <Stack mt={2} direction={'row'} justifyContent={'space-between'}>
            <Button color="error">Cancelar</Button>
            <Button onClick={cadastrarCelula}>Criar</Button>
          </Stack>
        </Box>
      </Modal>
    </>
  )
}
